import {AbstractEvent} from "@/modules/base/events";
import {Player} from "@/modules/team/entity";

export class BeforePlayerEnergyGainEvent extends AbstractEvent {
  constructor(
    public player: Player,
    public newEnergy: number,
  ) {
    super();
  }
}